import { ScholarshipPaymentDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ScholarshipPaymentActions from './scholarship-payment.actions';

export const SCHOLARSHIP_PAYMENT_FEATURE_KEY = 'payment';

export interface ScholarshipPaymentState
  extends EntityState<ScholarshipPaymentDto> {
  selectedScholarshipPaymentId?: string | number; // which ScholarshipPayment record has been selected
  loaded: boolean; // has the ScholarshipPayment list been loaded
  error?: string | null; // last none error (if any)
}

export interface ScholarshipPaymentPartialState {
  readonly [SCHOLARSHIP_PAYMENT_FEATURE_KEY]: ScholarshipPaymentState;
}

export const scholarshipPaymentAdapter: EntityAdapter<ScholarshipPaymentDto> = createEntityAdapter<
  ScholarshipPaymentDto
>({
  selectId: (scholarshipPayment) => scholarshipPayment.id,
  sortComparer: false,
});

export const initialState: ScholarshipPaymentState = scholarshipPaymentAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedScholarshipPaymentId: null,
  }
);

const scholarshipPaymentReducer = createReducer(
  initialState,
  on(ScholarshipPaymentActions.loadScholarshipPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipPaymentActions.loadScholarshipPaymentSuccess,
    (state, { scholarshipPayment }) =>
      scholarshipPaymentAdapter.addAll(scholarshipPayment, {
        ...state,
        loaded: true,
      })
  ),
  on(
    ScholarshipPaymentActions.loadScholarshipPaymentFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  on(ScholarshipPaymentActions.addScholarshipPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipPaymentActions.addScholarshipPaymentSuccess,
    (state, { newScholarshipPayment }) =>
      scholarshipPaymentAdapter.addOne(newScholarshipPayment, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ScholarshipPaymentActions.addScholarshipPaymentFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  on(ScholarshipPaymentActions.updateScholarshipPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipPaymentActions.updateScholarshipPaymentSuccess,
    (state, { updateScholarshipPayment }) =>
      scholarshipPaymentAdapter.upsertOne(updateScholarshipPayment, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ScholarshipPaymentActions.updateScholarshipPaymentFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  // search student

  on(
    ScholarshipPaymentActions.searchScholarshipPaymentRecord,
    (state, { query }) => {
      return {
        ...state,
        selectedScholarshipPaymentId: query,
        loaded: false,
        error: null,
      };
    }
  ),
  on(ScholarshipPaymentActions.removeScholarshipPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipPaymentActions.removeScholarshipPaymentSuccess,
    (state, { ids }) =>
      scholarshipPaymentAdapter.removeOne(ids, { ...state, loaded: false })
  ),
  on(
    ScholarshipPaymentActions.removeScholarshipPaymentFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ScholarshipPaymentState | undefined,
  action: Action
) {
  return scholarshipPaymentReducer(state, action);
}
